function openFile(blob) {
  const url = window.URL.createObjectURL(blob);
  const fileWindow = window.open(url, "_blank");
  fileWindow?.focus();
}

function calculateServiceLife(prop) {
  const installedYear = Number(prop.installed_date.split(" ")[0].split("-")[0]);

  let curAcc = 0;
  const serviceLifeSeries = [];
  serviceLifeSeries.push(100);
  for (let i = 0; i < prop.exceedance_levels.length; i += 1) {
    curAcc += prop.exceedance_levels[i][1];
    serviceLifeSeries.push(100 + curAcc);
  }

  for (let i = 0; i < prop.service_life_rates.length; i += 1) {
    serviceLifeSeries.push(prop.service_life_rates[i]);
  }

  const years = prop.exceedance_levels.length + prop.service_life_rates.length;

  curAcc = 0;
  const fpServiceLifeSeries = [];
  fpServiceLifeSeries.push(100);
  for (let i = 0; i < prop.exceedance_levels.length; i += 1) {
    curAcc += prop.exceedance_levels[i][1];
    fpServiceLifeSeries.push(100 + curAcc);
  }
  for (let i = 0; i < prop.fp_service_life_rates.length; i += 1) {
    fpServiceLifeSeries.push(prop.fp_service_life_rates[i]);
  }

  const fpYears = prop.exceedance_levels.length + prop.fp_service_life_rates.length;

  // eslint-disable-next-line no-param-reassign
  prop.service_life_series = serviceLifeSeries;
  // eslint-disable-next-line no-param-reassign
  prop.fp_service_life_series = fpServiceLifeSeries;
  // eslint-disable-next-line no-param-reassign
  prop.years = years;
  // eslint-disable-next-line no-param-reassign
  prop.fp_years = fpYears;
  // eslint-disable-next-line no-param-reassign
  prop.installed_year = installedYear;

  return installedYear + years;
}

function estimateBill(siteNumber, dayNumber) {
  return (
    estimateUploadData(dayNumber) + estimateDataTransfer(dayNumber) + estimateBasicFee(siteNumber)
  );
}

function estimateBasicFee(siteNumber) {
  return siteNumber * 13.2;
}

function estimateUploadData(dayNumber) {
  return 0.02 * dayNumber;
}

function estimateDataTransfer(dayNumber) {
  return 0.001 * dayNumber;
}

export {
  openFile,
  calculateServiceLife,
  estimateBill,
  estimateBasicFee,
  estimateUploadData,
  estimateDataTransfer,
};
